import React from 'react';
//MUI Components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import SelectInput from '../../common/SelectInput';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Android12Switch } from '../../common/Swtich';
import MultiselectInputChipbox from '../../common/MultiselectInputChipbox';
import SearchableSelectInput from '../../common/SearchableSelectInput';

//data constants
import {
	qualificationOptions,
	occupationOptions,
	annualIncomeOptions,
} from './../../constants/profileData';

function CareerDetails({
	qualifications,
	occupation,
	employedIn,
	annualIncome,
	data,
	isNRI,
	handleChange,
}) {
	return (
		<div>
			<React.Fragment>
				<Grid container spacing={3}>
					{/* Occupation */}
					<Grid item xs={12} sm={6}>
					<SearchableSelectInput
            name="occupation"
            label="Occupation *"
            value={occupation}
            handleChange={handleChange}
            placeholder="Select your Occupation"
            options={occupationOptions}
          />
					</Grid>
					{/* Annual Income */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='annualIncome'
							label='Annual Income'
							value={annualIncome}
							handleChange={handleChange}
							fullWidth
							variant='standard'
							placeholder='Select your Annual Income'
							options={annualIncomeOptions}
						/>
					</Grid>
					{/* Employed In */}
					<Grid item xs={12} sm={6}>
						<TextField
							name='employedIn'
							label='Employed In'
							value={employedIn}
							onChange={handleChange}
							error={data['employedIn'].error}
							helperText={
								data['employedIn'].error
									? data['employedIn'].helperText
									: ''
							}
							fullWidth
							variant='standard'
							placeholder='Enter your Organization/Company'
						/>
					</Grid>

					{/* Is NRI */}
					<Grid item xs={12} sm={6}>
						<Typography>Are you a NRI ?</Typography>
						<Stack direction='row' spacing={1} alignItems='center'>
							<Typography>No</Typography>
							<FormControlLabel
								control={
									<Android12Switch
										name='isNRI'
										checked={isNRI}
										onChange={handleChange}
									/>
								}
							/>

							<Typography>Yes</Typography>
						</Stack>
					</Grid>
					{/* Qualification  Test*/}
					<Grid
						item
						xs={12}
						sm={6}
						className='createprofile-qualification'
					>
						<MultiselectInputChipbox
							name='qualifications'
							label='Qualification'
							value={qualifications}
							onChange={handleChange}
							fullWidth
							variant='standard'
							placeholder='Select your Qualification'
							options={qualificationOptions}
						/>
					</Grid>
				</Grid>
			</React.Fragment>
		</div>
	);
}

export default CareerDetails;
